import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { Element } from '../element';
import * as styles from './progress-bar.styles';

/** @type {typeof import(".").ProgressBar} */
const ProgressBar = forwardRef(({ className, max = 100, value = 0, color, style, level, ...props }, ref) => {
  const percent = value / (max / 100);

  return (
    <Element
      as="div"
      className={clsx(styles.progressBar, className)}
      ref={ref}
      style={{ ...style, ...(color && { '--progress-bar-color': color }) }}
      {...props}
    >
      <div
        className={clsx(styles.components.bar, {
          [styles.variants[level]]: level,
        })}
        style={{ width: `${percent}%` }}
      />
      <div className={styles.components.fill} />
      <progress max={max} value={value} style={{ display: 'none' }}>
        {percent}%
      </progress>
    </Element>
  );
});

if (process.env.NODE_ENV !== 'production') {
  ProgressBar.displayName = 'ProgressBar';
}

export default ProgressBar;
